import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
      H <br />E <br />R <br />I <br />T <br />A <br />G <br />E <br />L <br />A <br />W <br /> S
      
      <a href="https://lin.ee/njDD62n"><i class="uil uil-line text-[40px]"></i></a>
      
    </div>
  )
}

export default Social

